import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accountDetails: null,
  loading: false,
  error: null,
};

const userAccountDetailsSlice = createSlice({
  name: 'userAccountDetails',
  initialState,
  reducers: {
    useraccountDetailsRequest(state, action) {
      state.loading = true;
      state.error = null;
    },
    useraccountDetailsFetched(state, action) {
      state.accountDetails = action.payload;
      state.loading = false;
      state.error = null;
    },
    useraccountDetailsFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetUserAccountDetailsSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

// Export the actions
export const {
  useraccountDetailsRequest,
  useraccountDetailsFetched,
  useraccountDetailsFailed,
  resetUserAccountDetailsSlice,
} = userAccountDetailsSlice.actions;

// Export the reducer
export default userAccountDetailsSlice.reducer;
